'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationParentChildCounts = exports.convertFilterDataToHashQuery = exports.extractHash = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends7 = require('babel-runtime/helpers/extends');

var _extends8 = _interopRequireDefault(_extends7);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.transformNeighborhoodsToCities = transformNeighborhoodsToCities;
exports.writeHashDataToFilterSet = writeHashDataToFilterSet;
exports.writeFiltersFromData = writeFiltersFromData;
exports.writeFiltersFromQuerystring = writeFiltersFromQuerystring;
exports.createQuerystringFromFilters = createQuerystringFromFilters;

var _effects = require('redux-saga/effects');

var _selectors = require('redux/saga/selectors');

var _request = require('redux/saga/selectors/request');

var _deep = require('helpers/deep');

var _filters = require('helpers/filters');

var _verify = require('helpers/verify');

var _filtersetIds = require('constants/filterset-ids');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(transformNeighborhoodsToCities),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(writeHashDataToFilterSet),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(writeFiltersFromData),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(writeFiltersFromQuerystring);

var extractHash = exports.extractHash = function extractHash(hashDescriptor) {
  return hashDescriptor ? hashDescriptor.match(/[^-]*/)[0] : '';
};

var convertFilterDataToHashQuery = exports.convertFilterDataToHashQuery = function convertFilterDataToHashQuery(filterSetId) {
  return function (state, msaId) {
    var defaultFilters = {
      entity_type: 'fitness-studio',
      extended: true,
      meta: true,
      msa_id: [String(msaId)]
    };
    var filters = (0, _deep.deepExtract)('filterSets.' + filterSetId + '.filters', state, {});
    var locationIds = (0, _keys2.default)((0, _deep.deepExtract)('location.itemIdSelected', filters, {}));
    var locationFilters = (0, _verify.isEmpty)(locationIds) ? {} : { location: locationIds };

    // If the the activity filter does not have a filterable property
    // that means the tags service was not used to dynamically populate any filters
    // and therefore use the 'legacy' logic to manually add activities to the tagFilters
    // Eventually tags will populate all filters and this logic can be removed
    var tagIds = void 0;
    if (filters.activity && typeof filters.activity.filterable === 'undefined') {
      tagIds = (0, _keys2.default)(filters.activity.itemIdSelected).map(String);
    } else {
      tagIds = (0, _filters.getFilterableTagIds)(filters).reduce(function (memo, filterId) {
        var itemIdSelected = (0, _deep.deepExtract)('itemIdSelected', filters[filterId], {});
        return [].concat((0, _toConsumableArray3.default)(memo), (0, _toConsumableArray3.default)((0, _keys2.default)(itemIdSelected).map(String)));
      }, []);
    }
    var tagFilters = tagIds.length > 0 ? { tag: tagIds } : {};

    var amenityFilters = (0, _keys2.default)(filters.amenity ? filters.amenity.itemIdSelected : {}).reduce(function (memo, amenity) {
      return (0, _extends8.default)({}, memo, (0, _defineProperty3.default)({}, amenity, ['true']));
    }, {});

    var levelFilters = (0, _keys2.default)(filters.level ? filters.level.itemIdSelected : {}).reduce(function (memo, level) {
      return (0, _extends8.default)({}, memo, (0, _defineProperty3.default)({}, level, ['true']));
    }, {});

    var allFilters = (0, _extends8.default)({}, defaultFilters, locationFilters, tagFilters, amenityFilters, levelFilters);

    return allFilters;
  };
};

var getLocationParentChildCounts = exports.getLocationParentChildCounts = function getLocationParentChildCounts(state, filterSet) {
  var parentedItemIds = (0, _deep.deepExtract)('filterSets.' + filterSet + '.filters.location.parentedItemIds', state, {});

  return (0, _keys2.default)(parentedItemIds).reduce(function (memo, parentId) {
    return (0, _extends8.default)({}, memo, (0, _defineProperty3.default)({}, parentId, parentedItemIds[parentId].length));
  }, {});
};

// Due to Search API limitations, we transform any L2 locations to the corresponding L3s,
// so we need to transform any full set of L3s back to its corresponding L2 on the way back.
function transformNeighborhoodsToCities(filterSet) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _ref, _ref2, locationParentChildCounts, itemsById, locationQueryChildCounts;

  return _regenerator2.default.wrap(function transformNeighborhoodsToCities$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.select)(getLocationParentChildCounts, filterSet), (0, _effects.select)(_deep.deepExtract.bind(null, 'filterSets.' + filterSet + '.filters.location.itemsById'))]);

        case 2:
          _ref = _context.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 2);
          locationParentChildCounts = _ref2[0];
          itemsById = _ref2[1];

          if (itemsById) {
            _context.next = 8;
            break;
          }

          return _context.abrupt('return', []);

        case 8:
          locationQueryChildCounts = location.reduce(function (memo, itemId) {
            return (0, _extends8.default)({}, memo, (0, _defineProperty3.default)({}, itemsById[itemId].parent_id, memo[itemsById[itemId].parent_id] + 1 || 1));
          }, {});
          return _context.abrupt('return', (0, _keys2.default)(location.reduce(function (memo, itemId) {
            return (0, _extends8.default)({}, memo, locationQueryChildCounts[itemsById[itemId].parent_id] === locationParentChildCounts[itemsById[itemId].parent_id] ? (0, _defineProperty3.default)({}, itemsById[itemId].parent_id, true) : (0, _defineProperty3.default)({}, itemId, true));
          }, {})).map(function (itemId) {
            return parseInt(itemId, 10);
          }));

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function writeHashDataToFilterSet(filterActions, _ref5) {
  var _extends6;

  var query = _ref5.query;
  var filterSet, location, filters, filterIds, tagIds, selectedTagsByFilterId, filterData;
  return _regenerator2.default.wrap(function writeHashDataToFilterSet$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          filterSet = filterActions.filterSet;
          _context2.next = 3;
          return (0, _effects.call)(transformNeighborhoodsToCities, filterSet, query.location);

        case 3:
          location = _context2.sent;
          _context2.next = 6;
          return (0, _effects.select)(_selectors.filterSetFilters, filterSet);

        case 6:
          filters = _context2.sent;
          filterIds = (0, _keys2.default)(filters);
          tagIds = query.tag || [];

          // Grab the parent (aka L2 tagIds) filterIds from each selected tagId

          selectedTagsByFilterId = filterIds.reduce(function (tagsByFilterId, filterId) {
            var selectedTagIdsForFilterId = tagIds.filter(function (tagId) {
              return filters[filterId].itemsById[tagId];
            });
            var newTagsByFilterId = !(0, _verify.isEmpty)(selectedTagIdsForFilterId) && (0, _defineProperty3.default)({}, filterId, selectedTagIdsForFilterId);

            return (0, _extends8.default)({}, tagsByFilterId, newTagsByFilterId);
          }, []);
          filterData = (0, _extends8.default)({}, selectedTagsByFilterId, { location: location } || {}, (_extends6 = {}, (0, _defineProperty3.default)(_extends6, _filtersetIds.LEVEL, ['level_beginner', 'level_all', 'level_advanced'].filter(function (level) {
            return (query[level] || [])[0] === 'true';
          })), (0, _defineProperty3.default)(_extends6, _filtersetIds.AMENITY, ['shower', 'towel', 'locker', 'mat'].filter(function (amenity) {
            return (query[amenity] || [])[0] === 'true';
          })), _extends6));
          _context2.next = 13;
          return (0, _effects.put)(filterActions.clearFilterSet());

        case 13:
          _context2.next = 15;
          return (0, _keys2.default)(filterData).filter(function (filterId) {
            return filterData[filterId] && filterData[filterId].length;
          }).map(function (filterId) {
            return (0, _effects.put)(filterActions.toggleItemId.apply(filterActions, [filterId].concat((0, _toConsumableArray3.default)(filterData[filterId]))));
          });

        case 15:
          _context2.next = 17;
          return (0, _effects.put)(filterActions.setClean());

        case 17:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function writeFiltersFromData(filterActions, filterSet, data) {
  var filters;
  return _regenerator2.default.wrap(function writeFiltersFromData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(filterActions.clearFilterSet());

        case 2:
          _context3.next = 4;
          return (0, _effects.select)(_selectors.filterSetFilters, filterSet);

        case 4:
          filters = _context3.sent;
          _context3.next = 7;
          return (0, _effects.all)([].concat((0, _toConsumableArray3.default)((0, _keys2.default)(data).reduce(function (actions, filterId) {
            var filterObj = filters[filterId];
            if (filterId === _filtersetIds.LOCATION) {
              var _data$filterId$split = data[filterId].split(','),
                  _data$filterId$split2 = (0, _toArray3.default)(_data$filterId$split),
                  lat = _data$filterId$split2[0],
                  lon = _data$filterId$split2[1],
                  name = _data$filterId$split2.slice(2);

              actions.push((0, _effects.put)(filterActions.setFilterValue(filterId, {
                lat: parseFloat(lat),
                lon: parseFloat(lon),
                name: name.join(',')
              })));
            } else if (filterObj && filterObj.isValueFilter) {
              actions.push((0, _effects.put)(filterActions.setFilterValue(filterId, data[filterId])));
            } else if (filterObj) {
              actions.push((0, _effects.put)(filterActions.toggleItemId.apply(filterActions, [filterId].concat((0, _toConsumableArray3.default)([].concat(data[filterId]))))));
            }
            return actions;
          }, []))));

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function writeFiltersFromQuerystring(filterActions, filterSet) {
  var queryData;
  return _regenerator2.default.wrap(function writeFiltersFromQuerystring$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_request.querySelector);

        case 2:
          queryData = _context4.sent;
          _context4.next = 5;
          return (0, _effects.call)(writeFiltersFromData, filterActions, filterSet, queryData);

        case 5:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function createQuerystringFromFilters(state, filterSet) {
  var filters = (0, _deep.deepExtract)('filterSets.' + filterSet + '.filters', state, {});

  return (0, _keys2.default)(filters).filter(function (filterId) {
    return filters[filterId].filtered;
  }).reduce(function (query, filterId) {
    // Cursors are too long to in the query at this time
    // Upcoming backend work will shorten them
    if (filterId === 'cursor') {
      return query;
    }

    if (filterId === _filtersetIds.LOCATION) {
      var _filters$filterId$val = filters[filterId].value,
          lat = _filters$filterId$val.lat,
          lon = _filters$filterId$val.lon,
          name = _filters$filterId$val.name;

      query[filterId] = lat + ',' + lon + ',' + name;
    } else if (filters[filterId].isValueFilter) {
      query[filterId] = filters[filterId].value;
    } else {
      query[filterId] = (0, _keys2.default)(filters[filterId].itemIdSelected);
    }
    return query;
  }, {});
}